// source: tableau/metrics/models/date_granularity.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return window;
}.call(null));

goog.exportSymbol('proto.tableau.metrics.models.p4.DateGranularity', null, global);
/**
 * @enum {number}
 */
proto.tableau.metrics.models.p4.DateGranularity = {
  DATE_GRANULARITY_UNKNOWN: 0,
  DATE_GRANULARITY_SECOND: 1,
  DATE_GRANULARITY_MINUTE: 2,
  DATE_GRANULARITY_HOUR: 3,
  DATE_GRANULARITY_DAY: 4,
  DATE_GRANULARITY_WEEK: 5,
  DATE_GRANULARITY_MONTH: 6,
  DATE_GRANULARITY_QUARTER: 7,
  DATE_GRANULARITY_YEAR: 8
};

goog.object.extend(exports, proto.tableau.metrics.models.p4);
